import { TokenTypes } from "@/types/token.type";

import hungerApi from "../../api/hunger.api";

import {
  getGroupListAction,
  postIdToSwitchGroupAction,
  setSelectedAction,
} from "./groupActions";
import { GroupDetail, GroupList } from "./groupTypes";

export const getGroupList = (): ThunkActionTypes => async (dispatch) => {
  try {
    const { data } = await hungerApi.get<GroupList>("/api/v3/mgt/group");

    dispatch(getGroupListAction(data));
  } catch (error: any) {
    throw new Error(error);
  }
};

export const postIdToSwitchGroup =
  (groupId: number): ThunkActionTypes =>
  async (dispatch) => {
    try {
      const {
        data: { group, token },
      } = await hungerApi.post<GroupDetail>("/api/v3/mgt/group/switch", {
        groupId,
      });
      localStorage.setItem(TokenTypes.ACCESS_TOKEN, token);
      dispatch(postIdToSwitchGroupAction(group));
    } catch (error: any) {
      throw new Error(error);
    }
  };

export const setSelected =
  (selected: boolean): ThunkActionTypes =>
  (dispatch) => {
    dispatch(setSelectedAction(selected));
  };
